/* eslint-disable camelcase */
export default function getInvoicesWithLineItems(distributionPlan) {
  if (!distributionPlan) {
    return {};
  }

  const invoices = {};

  distributionPlan?.forEach((planItem) => {
    const { invoice_id, line_item_id } = planItem;

    if (invoice_id) {
      if (!invoices[invoice_id]) {
        invoices[invoice_id] = [];
      }

      if (line_item_id && !invoices[invoice_id].includes(line_item_id)) {
        invoices[invoice_id].push(line_item_id);
      }
    }
  });

  return invoices;
}
